import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { Base_URL, tempURl } from "../url";

const Login2 = () => {
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const styles = {
    page: {
      height: "100vh",
      background:
        "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #6dd5fa 100%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Segoe UI, sans-serif",
    },

    card: {
      width: 380,
      padding: 30,
      borderRadius: 18,
      textAlign: "center",

      /* Glass Effect */
      background: "rgba(255, 255, 255, 0.18)",
      backdropFilter: "blur(14px)",
      WebkitBackdropFilter: "blur(14px)",

      border: "1px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 25px 50px rgba(0,0,0,0.25)",
    },

    logo: {
      width: 150,
      marginBottom: 10,
      filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.3))",
    },

    title: {
      color: "#ffffff",
      marginBottom: 20,
      fontWeight: 600,
      letterSpacing: 0.5,
    },

    input: {
      width: "100%",
      padding: 12,
      borderRadius: 10,
      border: "1px solid rgba(255,255,255,0.4)",
      marginBottom: 14,

      background: "rgba(255,255,255,0.25)",
      color: "#fff",
      outline: "none",

      fontSize: 14,
      backdropFilter: "blur(6px)",
    },

    passwordBox: {
      position: "relative",
    },

    eye: {
      position: "absolute",
      right: 14,
      top: 14,
      cursor: "pointer",
      color: "#fff",
      opacity: 0.8,
    },

    button: {
      width: "100%",
      padding: 13,
      borderRadius: 10,
      border: "none",

      background: "linear-gradient(135deg, #0b4d91 0%, #1976d2 100%)",
      color: "#fff",

      fontWeight: 600,
      fontSize: 15,
      cursor: "pointer",

      boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
    },

    microsoftBtn: {
      marginTop: 12,
      width: "100%",
      padding: 11,
      borderRadius: 10,
      border: "1px solid rgba(255,255,255,0.4)",

      background: "rgba(255,255,255,0.85)",
      color: "#000",

      cursor: "pointer",
      fontWeight: 500,
      boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
    },

    link: {
      marginTop: 12,
      fontSize: 13,
      cursor: "pointer",
      color: "#e3f2fd",
      textDecoration: "underline",
    },

    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(6px)",
    },

    footer: {
      marginTop: 20,
      fontSize: 11,
      color: "rgba(255,255,255,0.8)",
      letterSpacing: 0.5,
    },
  };
  // ---------------- PASSWORD LOGIN ----------------
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(username, password);
    } catch (err) {
      toast.error(err.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  // ---------------- MICROSOFT LOGIN ----------------
  const handleMicrosoftLogin = () => {
    window.location.href = `${tempURl}/auth/microsoft/login`;
  };

  // ---------------- SIGNUP ----------------
  const SignupForm = () => {
    const [data, setData] = useState({
      username: "",
      email: "",
      password: "",
    });
    const [showPwd, setShowPwd] = useState(false);

    const submitSignup = async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
        const res = await fetch(`${Base_URL}/Signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (res.ok) {
          toast.success("Signup successful. Please login.");
          setShowSignup(false);
        } else {
          toast.error("Signup failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div style={styles.card}>
        <h2 style={styles.title}>Sign Up</h2>

        <input
          style={styles.input}
          placeholder="Username"
          onChange={(e) => setData({ ...data, username: e.target.value })}
        />
        <input
          style={styles.input}
          placeholder="Email"
          onChange={(e) => setData({ ...data, email: e.target.value })}
        />

        <div style={styles.passwordBox}>
          <input
            style={styles.input}
            type={showPwd ? "text" : "password"}
            placeholder="Password"
            onChange={(e) => setData({ ...data, password: e.target.value })}
          />
          <span onClick={() => setShowPwd(!showPwd)} style={styles.eye}>
            {showPwd ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button style={styles.button} onClick={submitSignup}>
          Sign Up
        </button>

        <p style={styles.link} onClick={() => setShowSignup(false)}>
          Back to Login
        </p>
      </div>
    );
  };

  // ---------------- CHANGE PASSWORD ----------------
  const ChangePassword = () => {
    const [data, setData] = useState({
      userName: "",
      password: "",
      confirmPassword: "",
    });

    const submit = async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
        const res = await fetch(`${Base_URL}/Logins/UpdatePassword`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (res.ok) {
          toast.success("Password updated");
          setShowChangePassword(false);
        } else {
          toast.error("Update failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div style={styles.overlay}>
        <div style={styles.card}>
          <h3>Change Password</h3>

          <input
            style={styles.input}
            placeholder="Username"
            onChange={(e) => setData({ ...data, userName: e.target.value })}
          />
          <input
            style={styles.input}
            placeholder="Current Password"
            type="password"
            onChange={(e) => setData({ ...data, password: e.target.value })}
          />
          <input
            style={styles.input}
            placeholder="New Password"
            type="password"
            onChange={(e) =>
              setData({ ...data, confirmPassword: e.target.value })
            }
          />

          <button style={styles.button} onClick={submit}>
            Update
          </button>
          <p style={styles.link} onClick={() => setShowChangePassword(false)}>
            Cancel
          </p>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.page}>
      {!showSignup ? (
        <div style={styles.card}>
          <img
            src="https://userrdocument.blob.core.windows.net/userdocument/companylogos/9001/2000/91ee2746-b475-4d19-af4e-f1d5388f0241_WhatsApp_Image_2026-03-02_at_12.37.05_PM-removebg-preview.png"
            alt="logo"
            style={styles.logo}
          />

          <h2 style={styles.title}>Welcome Back</h2>

          <form onSubmit={handleLogin}>
            <input
              style={styles.input}
              placeholder="Username / Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <div style={styles.passwordBox}>
              <input
                style={styles.input}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                style={styles.eye}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button style={styles.button}>
              {loading ? "Logging in..." : "Log in"}
            </button>
          </form>

          <p style={styles.link} onClick={() => setShowChangePassword(true)}>
            Change Password?
          </p>

          <button style={styles.microsoftBtn} onClick={handleMicrosoftLogin}>
            Sign in with Microsoft
          </button>

          <p style={styles.link} onClick={() => setShowSignup(true)}>
            Don’t have an account? Sign up
          </p>
          <p style={styles.footer}>© 2026 ROSTERLEDGER™. All rights reserved</p>
        </div>
      ) : (
        <SignupForm />
      )}

      {showChangePassword && <ChangePassword />}
    </div>
  );
};

export default Login2;
